import { ReactNode } from 'react'

import { useNotification } from '~/shared/hooks/useNotification.ts'

export type InfoNotificationMobileProps = {
  content: string | ReactNode;
  defaultComp: ReactNode;
  disabled?: boolean;
  visible?: boolean;
  'aria-label'?: string;
}

export const InfoNotificationMobile = ({
  content,
  defaultComp,
  disabled = false,
  visible = false,
  'aria-label': ariaLabel,
}: InfoNotificationMobileProps) => {
  const { flashInfoMobile } = useNotification()

  // if notification is visible, it means there's no other click action on the component,
  // so button should be used, otherwise use div
  const Tag = visible ? 'button' : 'div'

  const onClick = () => {
    flashInfoMobile({
      message: content,
    })
  }

  return (
    <Tag aria-label={ariaLabel} style={{ opacity: disabled ? 0.5 : 1 }} onClick={visible ? onClick : undefined}>
      {defaultComp}
    </Tag>
  )
}